<template>
	<transition name="fade">
	<div class="status-message" :class="message.status" @click="hide"  v-if="isVisible">
		<p v-html="messageText"></p>
		<button v-if="message.isPermanent">Закрыть</button>
	</div>
	</transition>
</template>
<script>

export default {
	name: 'status',
	computed: {
		message() {
			return this.$store.state.message.message
		},

		isVisible() {
			return this.$store.state.message.messageVisible
		},

		messageText() {
			return this.$store.getters.messageText
		}
	},
	methods: {
		hide() {
			this.$store.dispatch('hideMessage');
		}
	}
}
</script>

<style>

.status-message {
	position: absolute;
	width: 80%;

	left: 0;
	right: 0;
	margin: 0 auto;

	background-color: black;
	color: white;

	padding: 1rem;
	top: 60px;

	z-index: 999;
	text-align: center;
}

.status-message.error {
	color: #FFA0A0;
	background-color: #503434;
	
	/* color: #F00;
	background-color: #FFF0F0; */
}


/*
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
*/
.fade-leave-active {
	transition: opacity .5s;
}
.fade-leave-to {
	opacity: 0;
}

/*
.status-message BUTTON {
	margin-top: 1rem;
	font-size: 0.8rem;
	border: 1px solid #FFF;
	padding: 0.3rem;
	background: none;
	color: #FFF;
}
*/

.status-message BUTTON {
	border: 2px solid #69808d;
	border-radius: 3px;
	background-color: #69808d;

	color: #F2F2F2;

	outline: 0;

	display: inline-block;
	/* width: 100%; */
	padding: 0.51em 1em;
	font-size: 110%;
}
</style>
